import { Component, OnInit } from '@angular/core';
import { Router, Params } from '@angular/router';
import { SearchService } from '../search.service';
import { AuthadminGuard } from '../adminauth/authadmin.guard'
import { Observable, of } from 'rxjs';
import * as firebase from 'firebase';

import { 
  AngularFirestore 
} from 'angularfire2/firestore';
import { AuthService } from 'src/app/core/auth.service';
// import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-adminlogin',
  templateUrl: './adminlogin.component.html',
  styleUrls: ['./adminlogin.component.css']
})
export class AdminloginComponent implements OnInit {
  email;
  password;
  // ret;

  constructor(private router: Router,private ret1:SearchService) {


   }

  ngOnInit() {
  }


  tryLogin(email,password)
  {
    // console.log("sdsa")
     this.email=email;
     this.password=password;

    if(email==="piyush" && password==="piyush12345")
    {
      // console.log("loged")
      this.ret1.ret= "d";


      this.router.navigate(['/adminhome']);
   
    }
    else
    {
    
    }
  }

}
